var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTokenSplash = function SvgTokenSplash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.499 2c9.5 0 9.499 10 9.499 10H19a2.34 2.34 0 0 0-3.044-1.092L13.5 12h-2l-2.457-1.092A2.34 2.34 0 0 0 6 12H2.998s0-10 9.501-10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22 12-5.742 5.44-2.302-.577 5.214-4.938-6.67-7.02-6.67 7.02 5.214 4.938-2.302.576L3 12l9.499-10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13.5 16.75-1-.25-1 .25V9h2zM8.5 19l4-1 4 1v2h-8z"
  })));
};
export default SvgTokenSplash;